<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل ميزة عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/featuresview">مميزات العقارات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل ميزة عقار</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="isLoader" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown me-2">
              <i class="bi bi-pencil-square me-2 text-brown"></i> عرض البيانات
            </h5>
            <div class="card shadow mb-4">
              <div v-if="hasError" class="text-center pt-3">
                <errorAlert  :alertMessage= "message" />
              </div>
              <div v-if="success" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <label for="">التصنيف</label>
                    <div>{{ categoryObj[category] }}</div>
                  </div>
                  <div class="col align-content-center text-center pt-3">
                    <img :src="MEDIA_URL+image" alt="" style="max-width: 200px;">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="form-group py-2">
                      <label>الاسم - عربي:</label>
                      <div>{{ name }}</div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group py-2">
                      <label>الاسم - إنجليزي:</label>
                      <div>{{ nameEn }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group py-2">
                      <label for="">الحاله :</label>
                      <div>{{ (status)? 'نشط' : 'غير نشط' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "FeaturesRead",
  data(){
    return {
      featuerId: this.$route.params.key,
      loading: false,
      hasError: false,
      success: false,
      message: "",
      name: "",
      nameEn: "",
      status: true,
      image: "",
      isLoader: false,
      category: "",
      categoryObj: {
        features: 'مميزات العقار',
        building_details: 'تفاصيل المبنى', 
        health_fitness: 'الصحة واللياقة', 
        places_facilities: 'الاماكن والمرافق القريبة', 
        entertainment: 'المرافق والترفيه', 
        services_maintenance: 'الخدمات والصيانة',
      }
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods:{
    getData() {
      this.hasError = false;
      this.isLoader = true;
      this.$http.get(`/api/admin/propertyFeatures/retrieve/${this.featuerId}`).then(res => {
        // console.log(res);
        this.isLoader = false;
        this.category = res.data.propertyFeature.category;
        this.name = res.data.propertyFeature.name;
        this.nameEn = res.data.propertyFeature.nameEn;
        this.image = res.data.propertyFeature.icon;
        this.status = res.data.propertyFeature.isActive;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoader = false;
        window.scroll(0,0);
      });
    }, 
  },
  created() {
    this.getData();
  }
};
</script>
